import { OriginConfigMap } from '../interfaces/app.config.interface';
import { environment as env } from 'src/environments/environment';

const APP_NAME = 'ConnectX';
const CLIENT_ID = env.clientId;
const SCOPES = [
	'CCAdmin',
	'profile',
	'email',
	'CCRuleService',
	'CCCameraDirectoryService',
	'cc_device-config.read_config',
	'cc_device-config.write_config',
	'orchestrate-manage',
];

export const originSpecific: OriginConfigMap[] = [
	{
		origins: [env.clientHost, 'commonheader.dev.commandcentral.com'],
		config: {
			appInsightsInstrumentationKey: '',
			appSpecificConfig: {
				scopes: SCOPES,
				clientId: CLIENT_ID,
				handleLegacyAdmin: false,
				developmentMode: env.developmentMode,
				singlePreprod: env.singlePreprod,
			},
			applicationName: APP_NAME,
		},
	},
];

// Copyright (c) Motorola Solutions Inc. All Rights Reserved.
